import { render, staticRenderFns } from "./DeliveryConfigManage.vue?vue&type=template&id=b76400fc&"
import script from "./DeliveryConfigManage.vue?vue&type=script&lang=js&"
export * from "./DeliveryConfigManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b76400fc')) {
      api.createRecord('b76400fc', component.options)
    } else {
      api.reload('b76400fc', component.options)
    }
    module.hot.accept("./DeliveryConfigManage.vue?vue&type=template&id=b76400fc&", function () {
      api.rerender('b76400fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/store/delivery-config/DeliveryConfigManage.vue"
export default component.exports